exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.toasted.bubble {\n    line-height: 1.4em !important;\n    padding-top: 10px !important;\n    padding-bottom: 10px !important;\n    border-radius: 8px;\n}\n.toasted-container .toasted .action {\n}\n.toasted-container .toasted.info .action {\n    color: #fff;\n}\n.flash-general-info .toasted.bubble {\n    max-width: 750px;\n    padding: 20px 40px !important;\n}\n.toasted.bubble.info {\n    background: var(--mid-olive);\n}\n.flash-warning .toasted.bubble.error {\n    background: var(--orange);\n}\n", ""]);

// exports
